import styled from 'styled-components';

import { Text } from '@/nova/components';
import { cardHover } from '@/nova/theme/configurator-keyframes';
import { CFG } from '../../../../../../theme/configurator-tokens';
import { FINISH } from '../../finish.tokens';

/* Friendly, centred error state shown when checkout can't start (no session / invoice
   / session failure) — replaces the old bare red sentence. Vertically centred in
   the payment pane body. */

export const Root = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px 28px;
  text-align: center;
`;

export const IconCircle = styled.span`
  display: flex;
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: 1px solid ${FINISH.errorIconBorder};
  background: ${FINISH.errorIconBg};
`;

export const Heading = styled(Text)`
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
  color: ${FINISH.errorHeading};
`;

export const Body = styled(Text)`
  max-width: 280px;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.45;
  color: ${FINISH.errorBody};
`;

export const RetryButton = styled.button`
  margin-top: 8px;
  display: flex;
  height: 48px;
  width: 100%;
  max-width: 280px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 9999px;
  border: none;
  background: ${CFG.brand};
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${FINISH.payButtonText};
  transition: opacity 150ms ease;

  /* Cursor-following hover glow + lit hairline ring (shared with the CTA Button). */
  ${cardHover}

  &:hover {
    opacity: 0.92;
  }
`;

export const RetryLabel = styled(Text)`
  display: inline;
`;

/* "Still having trouble? Contact support" — wraps a lead label + an inline brand
   email link, so it's a span (not styled(Text), which can't hold children). */
export const SupportLine = styled.span`
  margin-top: 4px;
  font-size: 14px;
  font-weight: 300;
  color: ${FINISH.errorSupportLead};
`;

export const SupportLink = styled(Text)`
  color: ${CFG.brandText};
  opacity: 0.72;
`;
